module.exports = __webpack_public_path__ + "fonts/cubeic.dcc2b6f1.ttf";